import gql from 'graphql-tag';
import * as Urql from 'urql';

import * as Types from './types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetBookingsExpandedCo2SumAggregateQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Container_Insights_Bookings_Expanded_Bool_Exp>;
}>;

export type GetBookingsExpandedCo2SumAggregateQuery = {
  __typename?: 'query_root';
  container_insights_bookings_expanded_aggregate: {
    __typename?: 'container_insights_bookings_expanded_aggregate';
    aggregate?: {
      __typename?: 'container_insights_bookings_expanded_aggregate_fields';
      sum?: {
        __typename?: 'container_insights_bookings_expanded_sum_fields';
        co2eq_kg?: any | null;
      } | null;
    } | null;
  };
};

export const GetBookingsExpandedCo2SumAggregateDocument = gql`
  query GetBookingsExpandedCO2SumAggregate(
    $where: container_insights_bookings_expanded_bool_exp
  ) {
    container_insights_bookings_expanded_aggregate(where: $where) {
      aggregate {
        sum {
          co2eq_kg
        }
      }
    }
  }
`;

export function useGetBookingsExpandedCo2SumAggregateQuery(
  options?: Omit<
    Urql.UseQueryArgs<GetBookingsExpandedCo2SumAggregateQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    GetBookingsExpandedCo2SumAggregateQuery,
    GetBookingsExpandedCo2SumAggregateQueryVariables
  >({ query: GetBookingsExpandedCo2SumAggregateDocument, ...options });
}
